export default "/_next/static/fonts/Graphik-Regular-fb0cb27361bfaf9a6dcebdce23b3bce4.woff";